<template>
  <section class="section">
    <div class="columns is-centered">
      <div class="column is-half opacity-box">
        <h1 class="title"> Sign Up </h1>
        <form @submit.prevent>
          <div class="field">
            <div class="control has-icons-left">
              <input class="input"
                v-model="username"
                type="username"
                placeholder="Username"
                required
              >
              <span class="icon is-small is-left">
                <font-awesome-icon icon="user"></font-awesome-icon>
              </span>
            </div>
          </div>
          <div class="field">
            <div class="control has-icons-left">
              <input class="input"
                v-model="email"
                type="email"
                placeholder="Email"
                required
              >
              <span class="icon is-small is-left">
                <font-awesome-icon icon="envelope"></font-awesome-icon>
              </span>
            </div>
          </div>
          <div class="field">
            <div class="control has-icons-left">
              <input class="input"
                v-model="password"
                type="password"
                placeholder="Password"
                required
              >
              <span class="icon is-small is-left">
                <font-awesome-icon icon="key"></font-awesome-icon>
              </span>
            </div>
          </div>
          <div class="field">
            <p class="control">
               <AsyncButton buttonClass="is-primary" @handle="handleRegister">
                Sign Up
              </AsyncButton>
            </p>
          </div>
        </form>
      </div>
    </div>
  </section>
</template>

<script>
import AsyncButton from '@/components/AsyncButton.vue';

export default {
  name: 'Register',
  components: {
    AsyncButton,
  },
  data() {
    return {
      username: '',
      email: '',
      password: '',
      confirmPassword: '',
    };
  },
  methods: {
    async handleRegister() {
      const { username, email, password } = this;
      try {
        await this.$api('user/register', { username, email, password });
        await this.$store.dispatch('auth/login', { username, password });
        this.$router.push({ name: 'Workouts' });
      } catch (error) {
        this.$store.dispatch('notification/setError', error.getMessage());
      }
    },
  },
};
</script>
